$(document).ready(function ($) {

  // $('.modal').popup({
  //   transition: 'all 0.3s'
  // });

  // Megamenu
  if ($(window).width() > 767) { // Hide on mobile
    $('.header__nav ul li').mouseenter(function () {
      $(this).find('.sub-nav').stop().slideDown(500);
    });

    $('.header__nav ul li').mouseleave(function () {
      $(this).find('.sub-nav').stop().slideUp(500);
    });
  }

  $('.mobile_nav, .mobile_search').show();

  // Open mobile menu when click on hamburger
  $('.header--mobile .hamb').click(function (evt) {
    evt.preventDefault();
    $(this).toggleClass('open');

    if ($('.mobile_nav').hasClass('opened')) {
      $('.mobile_nav').removeClass('opened');
    } else {
      $('.mobile_nav').addClass('opened');
    }
  });

  $('.mobile_nav > ul > li > a.dropdown').click(function (e) {
    e.preventDefault();
    $('.mobile_nav > ul > li > .subnav').removeClass('opened');
    $(this).parent().find('>ul').addClass('opened');
  });

  $('.mobile_nav > ul > li > .subnav > li a.dropdown').click(function (e) {
    e.preventDefault();
    $('.mobile_nav > ul > li > .subnav > li > .subnav').removeClass('opened');
    $(this).parent().find('>ul').addClass('opened');
  });

  $('.mobile_nav > ul > li > .subnav > li > a.back').click(function (e) {
    e.preventDefault();
    $(this).parent().parent().removeClass('opened');
  });

  $('.mobile_nav > ul > li > .subnav > li > .subnav > li > a.back').click(function (e) {
    e.preventDefault();
    $(this).parent().parent().removeClass('opened');
  });


  $('.header__search input').keyup(function () {
    var value = $(this).val();
    if (value.length > 0) {
      $('.search_results').fadeIn(400);
    } else {
      $('.search_results').fadeOut(400);
    }
  });

  // $('.header__controls .minicart > a').click(function (e) {
  //   e.preventDefault();
  //   $(this).parent().find('.minicart_object').toggleClass('opened');
  //
  //   if($(this).parent().find('.minicart_object').hasClass('opened')) {
  //     $(this).parent().find('.minicart_object').fadeOut(300);
  //   } else {
  //     $(this).parent().find('.minicart_object').fadeIn(300);
  //   }
  // });

  if ($('.product__information').length) {
    $('.product__information .item > a').click(function (e) {
      e.preventDefault();
      $('.product__information .item > a').not(this).parent().removeClass('opened');
      $('.product__information .item > a').not(this).parent().find('.content').hide();
      if ($(this).parent().hasClass('opened')) {
        $(this).parent().removeClass('opened');
        $(this).parent().find('.content').slideUp(300);
      } else {
        $(this).parent().addClass('opened');
        $(this).parent().find('.content').slideDown(300);
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname && this.id) {
          var target = $('#' + this.id).parent();
          target = target.length ? target : $('[name=' + this.id + ']');

          var elementTop = target.offset().top;
          var elementBottom = elementTop + target.outerHeight();
          var viewportTop = $(window).scrollTop();
          var viewportBottom = viewportTop + $(window).height();

          if (target.length && !(elementBottom > viewportTop && elementTop < viewportBottom && viewportBottom > elementBottom && viewportTop < elementTop)) {
            $('html, body').stop().animate({
              scrollTop: target.offset().top - 80
            }, 0);
            return false;
          }
        }
      }
    });
  }

  if ($('.cart__information').length) {
    $('.cart__information .item a').click(function (e) {
      e.preventDefault();
      $('.cart__information .item a').not(this).parent().removeClass('opened');
      $('.cart__information .item a').not(this).parent().find('.content').slideUp(300);
      if ($(this).parent().hasClass('opened')) {
        $(this).parent().removeClass('opened');
        $(this).parent().find('.content').slideUp(300);
      } else {
        $(this).parent().addClass('opened');
        $(this).parent().find('.content').slideDown(300);
      }
    });
  }

  if ($('.faq').length) {
    $('.faq .item a').click(function (e) {
      e.preventDefault();
      $('.faq .item a').not(this).parent().removeClass('opened');
      $('.faq .item a').not(this).parent().find('.content').slideUp(300);
      if ($(this).parent().hasClass('opened')) {
        $(this).parent().removeClass('opened');
        $(this).parent().find('.content').slideUp(300);
      } else {
        $(this).parent().addClass('opened');
        $(this).parent().find('.content').slideDown(300);
      }
    });
  }

  if ($('.products_slider#slider_one').length) {
    var swiper_one = new Swiper('.products_slider#slider_one .slider-wrap > .swiper-container', {
      slidesPerView: 4,
      navigation: {
        nextEl: '.products_slider#slider_one .slider-wrap > .swiper-button-next',
        prevEl: '.products_slider#slider_one .slider-wrap > .swiper-button-prev',
      },
      breakpoints: {
        992: {
          slidesPerView: 3
        },
        767: {
          slidesPerView: 1
        }
      }
    });

    var swiper_two = new Swiper('.products_slider#slider_two .slider-wrap > .swiper-container', {
      slidesPerView: 4,
      navigation: {
        nextEl: '.products_slider#slider_two .slider-wrap > .swiper-button-next',
        prevEl: '.products_slider#slider_two .slider-wrap > .swiper-button-prev',
      },
      breakpoints: {
        992: {
          slidesPerView: 3
        },
        767: {
          slidesPerView: 1
        }
      }
    });
  }

  // Sorting Views list
  $('.sorting__list  .sort > a').click(function (e) {
    e.preventDefault();
    if($(this).parent().find('ul').hasClass('opened')) {
      $(this).parent().find('ul').fadeOut(600);
      $(this).parent().find('ul').removeClass('opened');
      $(this).parent().removeClass('opened');
    } else {
      $(this).parent().find('ul').fadeIn(600);
      $(this).parent().find('ul').addClass('opened');
      $(this).parent().addClass('opened');
    }
  });

  // Sorting Types list
  $('.sorting__list .count > a').click(function (e) {
    e.preventDefault();
    if($(this).parent().find('ul').hasClass('opened')) {
      $(this).parent().find('ul').fadeOut(600);
      $(this).parent().find('ul').removeClass('opened');
      $(this).parent().removeClass('opened');
    } else {
      $(this).parent().find('ul').fadeIn(600);
      $(this).parent().find('ul').addClass('opened');
      $(this).parent().addClass('opened');
    }
  });

  // Sorting Show list
  $('.sorting__view > a').click(function (e) {
    e.preventDefault();
    if ($(this).parent().find('ul').hasClass('opened')) {
      $(this).parent().find('ul').fadeOut(600);
      $(this).parent().find('ul').removeClass('opened');
      $(this).parent().removeClass('opened');
    } else {
      $(this).parent().find('ul').fadeIn(600);
      $(this).parent().find('ul').addClass('opened');
      $(this).parent().addClass('opened');
    }
  });

  // Sorting Pages list
  $('.more-pages > a').click(function (e) {
    e.preventDefault();
    if ($(this).parent().find('ul').hasClass('opened')) {
      $(this).parent().find('ul').fadeOut(600);
      $(this).parent().find('ul').removeClass('opened');
      $(this).parent().removeClass('opened');
    } else {
      $(this).parent().find('ul').fadeIn(600);
      //$('.more-pages ul .inner').jScrollPane();
      $(this).parent().find('ul').addClass('opened');
      $(this).parent().addClass('opened');
    }
  });

  // Sorting types list
  $('.sorting__types > a').click(function (e) {
    e.preventDefault();
    if ($(this).parent().find('ul').hasClass('opened')) {
      $(this).parent().find('ul').fadeOut(600);
      $(this).parent().find('ul').removeClass('opened');
      $(this).parent().removeClass('opened');
    } else {
      $(this).parent().find('ul').fadeIn(600);
      $(this).parent().find('ul').addClass('opened');
      $(this).parent().addClass('opened');
    }
  });

  // Open mobile menu when click on hamburger
  $('.checkout_page .hamb').click(function () {
    $(this).toggleClass('open');

    if ($('.header').hasClass('opened')) {
      $('.header').slideUp(500).removeClass('opened');
      $('.checkout_header').removeClass('parent_active');
    } else {
      $('.header').addClass('opened').slideDown(500);
      $('.checkout_header').addClass('parent_active');
    }
  });

  $('a[href*="#"]:not([href="#"]):not(.open_tabs_link)').click(function () {
    if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      if (target.length) {
        $('html, body').animate({
          scrollTop: target.offset().top - 80
        }, 1000);
        return false;
      }
    }
  });

  var $ordersTable = $('.profile__orders'),
    $ordersTableItem = $ordersTable.find('.item');
  if ($ordersTable.length) {
    $ordersTableItem.find('a.expand').click(function (e) {
      e.preventDefault();

      if ($(this).parent().parent().hasClass('opened')) {
        $(this).parent().parent().removeClass('opened');
        $(this).parent().parent().find('.order-details').slideUp(300);
      } else {
        $('.profile__orders .item').removeClass('opened');
        $('.order-details').slideUp(300);
        $(this).parent().parent().addClass('opened');
        $(this).parent().parent().find('.order-details').slideDown(300);
      }

    });
  }

  // var $returnsTable = $('.returns_table'),
  //   $returnsTableItem = $returnsTable.find('.item');
  // if ($returnsTable.length) {
  //   $returnsTableItem.find('.expand a').click(function (e) {
  //     e.preventDefault();
  //
  //     if ($(this).parent().parent().parent().hasClass('opened')) {
  //       $(this).parent().parent().parent().removeClass('opened');
  //       $(this).parent().parent().parent().find('.return_details').slideUp(300);
  //       $(this).text('zwróć');
  //     } else {
  //       $('.returns_table .item').removeClass('opened');
  //       $('.return_details').slideUp(300);
  //       $(this).text('Anuluj');
  //       $(this).parent().parent().parent().addClass('opened');
  //       $(this).parent().parent().parent().find('.return_details').slideDown(300);
  //     }
  //
  //   });
  // }


  $('.open_search').click(function (e) {
    e.preventDefault();
    $('.mobile_search').addClass('opened');
  });

  $('.close_search').click(function (e) {
    e.preventDefault();
    $('.mobile_search').removeClass('opened');
  });

  $('.filters_open').click(function (e) {
    e.preventDefault();
    $('.filters').addClass('opened');
  });

  $('.close_filters').click(function (e) {
    e.preventDefault();
    $('.filters').removeClass('opened');
  });

  $('.sorting_open').click(function (e) {
    e.preventDefault();
    $('.mobile_sorting').addClass('opened');
  });

  $('.sorting_close').click(function (e) {
    e.preventDefault();
    $('.mobile_sorting').removeClass('opened');
  });

});
